/**
 * ObsoleteDialog Component
 * Marks the selected Reseller Assets files as obsolete: they stay available
 * for customers on older machines but are hidden by default, optionally
 * pointing to the file that replaces them.
 */

import React, { useState } from 'react';
import { markAssetsObsolete } from './assetEditorApi';

const fileLabel = (file) => {
  const ext = file.extension ? `.${file.extension}` : '';
  return file.name && ext && !file.name.toLowerCase().endsWith(ext.toLowerCase()) ? file.name + ext : file.name;
};

const ObsoleteDialog = ({ files, candidates, onClose, onDone }) => {
  const [note, setNote] = useState('');
  const [replacedById, setReplacedById] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await markAssetsObsolete(files.map(f => String(f.id)), { note: note.trim(), replacedById });
      onDone();
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div className="rf-obsolete-dialog-backdrop" onClick={onClose}>
      <form className="rf-obsolete-dialog" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <h3>Mark as obsolete</h3>
        <p className="rf-obsolete-dialog-summary">
          {files.length === 1 ? `"${fileLabel(files[0])}"` : `${files.length} files`} will stay available
          for customers who still need {files.length === 1 ? 'it' : 'them'} (e.g. older machines), but
          {files.length === 1 ? ' is' : ' are'} hidden unless "Show obsolete" is on.
        </p>
        <label htmlFor="rf-obsolete-note">Who still needs it? <span className="rf-optional">(optional)</span></label>
        <input
          id="rf-obsolete-note"
          type="text"
          maxLength={300}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="e.g. Machines built before 2025"
          autoFocus
        />
        <label htmlFor="rf-obsolete-replacement">Replaced by <span className="rf-optional">(optional)</span></label>
        <select id="rf-obsolete-replacement" value={replacedById} onChange={(e) => setReplacedById(e.target.value)}>
          <option value="">- No replacement -</option>
          {candidates.map(file => (
            <option key={file.id} value={String(file.id)}>{fileLabel(file)}</option>
          ))}
        </select>
        {error && <p className="rf-obsolete-dialog-error">{error}</p>}
        <div className="rf-obsolete-dialog-actions">
          <button type="button" className="rf-btn rf-btn-secondary rf-btn-sm" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" className="rf-btn rf-btn-primary rf-btn-sm" disabled={busy}>
            {busy ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-archive"></i>} Mark obsolete
          </button>
        </div>
      </form>
    </div>
  );
};

export default ObsoleteDialog;
